import React,  { useEffect, useState } from 'react';
import moment from 'moment';
import auth from '../Service/AuthFetchService';
import {
    Button,
    Tabs,
    Table,
    Row,
    Col,
    message,
    Popconfirm
} from 'antd';
import {
    PlusOutlined
} from '@ant-design/icons';
import RealtimeAnalysis from './RealtimeAnalysisComponent'
import './EventAnalysis.css'
import { isEmpty, isNotEmpty, samplingConstants } from '../Service/Utils';
import UIFetchService from '../Service/UIFetchService';


class EventAnalysisView extends React.Component {

    constructor() {
        super()
        this.state = {
            user: null,
            templates: [],
            tabs: [],
            activeKey: 'realtimeAnalysis',
            eventSelectorsJson: '',
            showingSaveModal: false,
            defId: null
        }
    }

    async componentDidMount() {
        const user = await auth.authenticate();
        window.CyaLogger?.sendCustomEvent("page_view", null, "datap_liuliagfenxi_pv", { page_name: "事件分析", user_name: user.account })
        window.CyaLogger?.sendCustomEvent('page_view', '事件分析', 'event_analyse_view', {
            event_date: moment().format('YYYY-MM-DD'),
            user_name: user.account
        })
        
        this.setState({ user: user })
    }

    render() {  
        let search = this.props.location.search // "?def_id=1&a=b&c=d"
        let defId = null
        if (search.length > 0) {
           search = search.substring(1) // "def_id=1&a=b&c=d"
           const params = search.split('&')
           for (const param of params) {
               const pair = param.split('=')
               if (pair[0] === 'def_id') {
                   defId = pair[1]
                   break
               }
           }

        }

        return <>
            <Row className='event-row'
                //style={{ backgroundColor: '#F7F9FA' }}
            >
            <Col flex="25px" ></Col>
            <Col flex="auto">
            <Tabs className='event-tabs' type="editable-card" hideAdd
                style={{backgroundColor: '#fff'}}
                activeKey={this.state.activeKey} 
                onChange={(k) => {
                    const eventName = k === 'realtimeAnalysis' ? 'event_analyse_view' : 'mould_list_view'
                    window.CyaLogger?.sendCustomEvent('page_view', '事件分析', eventName, {
                        event_date: moment().format('YYYY-MM-DD'),
                        user_name: this.state.user.account
                    })
                    this.setState({ activeKey: k })
                }}
            >
                {this.state.user == null ? null :<>
                <Tabs.TabPane tab="事件分析" key="realtimeAnalysis" closable={false}>
                    <RealtimeAnalysis user={this.state.user} defId={defId} />
                </Tabs.TabPane >
                <Tabs.TabPane tab="模板列表" key="templateList" closable={false}>
                    {this.state.activeKey === 'templateList' ? 
                    <EventAnalysisTemplateList /> : null }
                </Tabs.TabPane >
                </>
                }
            </Tabs>
            </Col>
            <Col flex="25px" ></Col>
            </Row>
            
        </>
    }
}

function EventAnalysisTemplateList(props) {
    const [keyword, setKeyword] = useState(null)
    const [onlyMe, setOnlyMe] = useState(false)
    const [templateList, setTemplateList] = useState(null)
    const [total, setTotal] = useState(0)
    const [current, setCurrent] = useState(1)
    const [pageSize, setPageSize] = useState(20)

    useEffect(() => {
        _refreshTemplateList(1)
    }, [keyword, onlyMe])

    const _refreshTemplateList = (pidx, psz, filters) => {
        const queries = []
        if (pidx) {
            setCurrent(pidx)
            queries.push(`pageIndex=${pidx}`)
        } else {
            queries.push(`pageIndex=${current}`)
        }
        if (psz) {
            setPageSize(psz)
            queries.push(`pageSize=${psz}`)
        } else {
            queries.push(`pageSize=${pageSize}`)
        }
        if (keyword != null && isNotEmpty(keyword)) {
            queries.push(`keyword=${keyword}`)
        }
        if (onlyMe) {
            queries.push(`onlyMe=true`)
        }
        if (filters) {
            queries.push(`filters=${encodeURI(JSON.stringify(filters))}`)
        }

        UIFetchService.get(`/api/v1/sampling/event/templates/list?${queries.join('&')}`)
            .then((rv) => {
                if (rv) {
                    setTotal(rv.total)
                    setTemplateList(rv.items)
                }
            })
    }

    const columns = [
        {
            title: "模板名称",
            dataIndex: "name",
            render: (_, record) => {
                return <a href={`/real_time/event_analysis/template/${record.id}`}>{record.name}</a>
            }
        },
        {
            title: "创建人",
            dataIndex: "creator"
        },
        {
            title: "创建时间",
            dataIndex: "createdAt",
            render: (time) => moment(time).format('YYYY-MM-DD HH:mm:ss')
        },
        {
            title: "更新时间",
            dataIndex: "updatedAt",
            render: (time) => moment(time).format('YYYY-MM-DD HH:mm:ss')
        },
        {
            title: "操作",
            key: "operate",
            fixed: "right",
            render: (_, record) => <> {record.owned ? <Row>
                <Col>
                <Popconfirm
                    title="是否删除指定的模板？"
                    onConfirm={() => {
                        UIFetchService.method('DELETE', `/api/v1/sampling/event/template/${record.id}`)
                            .then((cnt) => {
                                if (cnt != null) {
                                    message.success("删除模板成功")
                                    _refreshTemplateList()
                                } else {
                                    message.error("删除模板失败")
                                }
                            })
                    }}
                    onCancel={() => { }}
                    okText="删除"
                    okButtonProps={{ danger: true }}
                    cancelText="取消"
                >
                    <Button size='small' type="link" danger >删除</Button>
                </Popconfirm>
                </Col>
            </Row> : null}
            </>
        }
    ]

    return (
        <>
        <Row>
            <Col flex="100%" style={{ padding: '10px' }}>
                <Table
                    dataSource={templateList}
                    columns={columns}
                    bordered
                    size="small"
                    pagination={{
                        total: total,
                        current: current,
                        pageSize: pageSize,
                    }}
                    rowKey="id"
                    style={{
                        width: '100%',
                    }}
                    onChange={(pagination, filters, sorter, { action }) => {
                        _refreshTemplateList(pagination.current, pagination.pageSize, filters)
                    }}
                />
            </Col>
        </Row>
        </>
    )
}



export default EventAnalysisView